import {
  SectionElement,
  defineElement,
  on,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/common-collection-hero/common-collection-hero.ts
var CommonCollectionHero = class extends SectionElement {
  showAllLinks() {
    this.linkBlocks.forEach((block) => {
      block.classList.remove("hidden");
    });
    this.showAllButton.remove();
  }
};
__decorateClass([
  queryAll("[data-hero-link-block]")
], CommonCollectionHero.prototype, "linkBlocks", 2);
__decorateClass([
  query("[data-show-all-links]")
], CommonCollectionHero.prototype, "showAllButton", 2);
__decorateClass([
  on("click", "[data-show-all-links]")
], CommonCollectionHero.prototype, "showAllLinks", 1);
CommonCollectionHero = __decorateClass([
  defineElement("common-collection-hero")
], CommonCollectionHero);
export {
  CommonCollectionHero
};
